<template>
  <div class="package-status">
    <!-- Hiển thị thông báo dựa trên statusType -->

    <!-- Gói cước đã hết hạn (ưu tiên cao nhất) -->
    <div v-if="statusType === 'expired'" class="modern-status-card danger">
      <div class="icon-section">
        <div class="icon-badge danger-badge">
          <svg width="22" height="22" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 9.88644C15.5648 9.88644 16.0227 10.3443 16.0227 10.9092V15.0001C16.0227 15.5649 15.5648 16.0228 15 16.0228C14.4352 16.0228 13.9773 15.5649 13.9773 15.0001V10.9092C13.9773 10.3443 14.4352 9.88644 15 9.88644Z"
              fill="currentColor" />
            <path
              d="M15 18.0682C14.4352 18.0682 13.9773 18.5261 13.9773 19.0909C13.9773 19.6558 14.4352 20.1137 15 20.1137H15.0102C15.5751 20.1137 16.033 19.6558 16.033 19.0909C16.033 18.5261 15.5751 18.0682 15.0102 18.0682H15Z"
              fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.0427 4.04955C10.2345 3.85775 10.4947 3.75 10.7659 3.75H19.2341C19.5053 3.75 19.7655 3.85775 19.9573 4.04955L25.9505 10.0427C26.1422 10.2345 26.25 10.4947 26.25 10.7659V19.2341C26.25 19.5053 26.1422 19.7655 25.9505 19.9573L19.9573 25.9505C19.7655 26.1422 19.5053 26.25 19.2341 26.25H10.7659C10.4947 26.25 10.2345 26.1422 10.0427 25.9505L4.04955 19.9573C3.85775 19.7655 3.75 19.5053 3.75 19.2341V10.7659C3.75 10.4947 3.85775 10.2345 4.04955 10.0427L10.0427 4.04955ZM11.1895 5.79545L5.79545 11.1895V18.8105L11.1895 24.2045H18.8105L24.2045 18.8105V11.1895L18.8105 5.79545H11.1895Z"
              fill="currentColor" />
          </svg>
        </div>
      </div>
      <div class="content-section">
        <div class="card-title">
          {{ $t("expireYourPackage") }}
          <a class="modern-cta" @click.prevent="goToDetail">
            {{ $t("viewDetails") }} <b-icon icon="arrow-up-right" class="ml-1" font-scale="0.8"></b-icon>
          </a>
        </div>
        <div class="card-info danger-light">
          {{ $t("pleaseRenewPackage") }}
        </div>
        <div class="card-footer-text">
          {{ $t("thankYouForBeingWithUs") }}!
        </div>
      </div>
    </div>

    <!-- Đã đạt giới hạn cuộc họp (ưu tiên 2) -->
    <div v-else-if="statusType === 'limit-reached'" class="modern-status-card danger">
      <div class="icon-section">
        <div class="icon-badge danger-badge">
          <svg width="22" height="22" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 9.88644C15.5648 9.88644 16.0227 10.3443 16.0227 10.9092V15.0001C16.0227 15.5649 15.5648 16.0228 15 16.0228C14.4352 16.0228 13.9773 15.5649 13.9773 15.0001V10.9092C13.9773 10.3443 14.4352 9.88644 15 9.88644Z"
              fill="currentColor" />
            <path
              d="M15 18.0682C14.4352 18.0682 13.9773 18.5261 13.9773 19.0909C13.9773 19.6558 14.4352 20.1137 15 20.1137H15.0102C15.5751 20.1137 16.033 19.6558 16.033 19.0909C16.033 18.5261 15.5751 18.0682 15.0102 18.0682H15Z"
              fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M10.0427 4.04955C10.2345 3.85775 10.4947 3.75 10.7659 3.75H19.2341C19.5053 3.75 19.7655 3.85775 19.9573 4.04955L25.9505 10.0427C26.1422 10.2345 26.25 10.4947 26.25 10.7659V19.2341C26.25 19.5053 26.1422 19.7655 25.9505 19.9573L19.9573 25.9505C19.7655 26.1422 19.5053 26.25 19.2341 26.25H10.7659C10.4947 26.25 10.2345 26.1422 10.0427 25.9505L4.04955 19.9573C3.85775 19.7655 3.75 19.5053 3.75 19.2341V10.7659C3.75 10.4947 3.85775 10.2345 4.04955 10.0427L10.0427 4.04955ZM11.1895 5.79545L5.79545 11.1895V18.8105L11.1895 24.2045H18.8105L24.2045 18.8105V11.1895L18.8105 5.79545H11.1895Z"
              fill="currentColor" />
          </svg>
        </div>
      </div>
      <div class="content-section">
        <div class="card-title">
          {{ $t("yourPlanRemaining") }} {{ remainingDays }} {{ $t("day") }}
          <a class="modern-cta" @click.prevent="goToDetail">
            {{ $t("viewDetails") }} <b-icon icon="arrow-up-right" class="ml-1" font-scale="0.8"></b-icon>
          </a>
        </div>
        <div class="card-info">
          {{ $t("countThisMonth") }}:
          <span class="highlight-badge danger">{{ monthlyMeetingByCustomer }}/{{ numberOfMeetings }} ({{
            $t("limitReached") }})</span>
        </div>
        <div class="card-info danger-light">
          {{ $t("pleaseUpgrade") }}
        </div>
        <div class="card-footer-text">
          {{ $t("thankYouForBeingWithUs") }}!
        </div>
      </div>
    </div>

    <!-- Gói cước sắp hết hạn (dưới 7 ngày) (ưu tiên 3) -->
    <div v-else-if="statusType === 'expiring-soon'" class="modern-status-card warning">
      <div class="icon-section">
        <div class="icon-badge warning-badge">
          <svg width="22" height="22" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.7914 13.6777C19.1908 13.2783 19.1908 12.6307 18.7914 12.2313C18.392 11.8319 17.7444 11.8319 17.345 12.2313L13.9773 15.5991L12.655 14.2768C12.2556 13.8774 11.6081 13.8774 11.2087 14.2768C10.8093 14.6762 10.8093 15.3237 11.2087 15.7231L13.2541 17.7686C13.6535 18.168 14.3011 18.168 14.7005 17.7686L18.7914 13.6777Z"
              fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15 3.75C8.78664 3.75 3.75 8.78664 3.75 15C3.75 21.2134 8.78664 26.25 15 26.25C21.2134 26.25 26.25 21.2134 26.25 15C26.25 8.78664 21.2134 3.75 15 3.75ZM5.79545 15C5.79545 9.91631 9.91631 5.79545 15 5.79545C20.0837 5.79545 24.2045 9.91631 24.2045 15C24.2045 20.0837 20.0837 24.2045 15 24.2045C9.91631 24.2045 5.79545 20.0837 5.79545 15Z"
              fill="currentColor" />
          </svg>
        </div>
      </div>
      <div class="content-section">
        <div class="card-title">
          {{ $t("yourPlanRemaining") }} <span class="days-pill warning">{{ remainingDays }} {{ $t("day") }}</span>
          <a class="modern-cta" @click.prevent="goToDetail">
            {{ $t("viewDetails") }} <b-icon icon="arrow-up-right" class="ml-1" font-scale="0.8"></b-icon>
          </a>
        </div>
        <div class="card-info warning-text">
          {{ $t("pleaseRenewSoon") }}
        </div>
        <div class="card-info secondary">
          {{ $t("countThisMonth") }}: <strong>{{ monthlyMeetingByCustomer }}/{{ numberOfMeetings }}</strong>
        </div>
        <div class="card-footer-text">
          {{ $t("youCanStillHostUpTo") }} <strong>{{ duration }} {{ $t("hours") }}</strong> {{ $t("with") }}
          <strong>{{ maximumNumberOfParticipantsInMeeting }} {{ $t("participants") }}</strong>
        </div>
      </div>
    </div>

    <!-- Gói cước còn hạn bình thường (ưu tiên thấp nhất) -->
    <div v-else-if="statusType === 'active'" class="modern-status-card success">
      <div class="icon-section">
        <div class="icon-badge success-badge">
          <svg width="22" height="22" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.7914 13.6777C19.1908 13.2783 19.1908 12.6307 18.7914 12.2313C18.392 11.8319 17.7444 11.8319 17.345 12.2313L13.9773 15.5991L12.655 14.2768C12.2556 13.8774 11.6081 13.8774 11.2087 14.2768C10.8093 14.6762 10.8093 15.3237 11.2087 15.7231L13.2541 17.7686C13.6535 18.168 14.3011 18.168 14.7005 17.7686L18.7914 13.6777Z"
              fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15 3.75C8.78664 3.75 3.75 8.78664 3.75 15C3.75 21.2134 8.78664 26.25 15 26.25C21.2134 26.25 26.25 21.2134 26.25 15C26.25 8.78664 21.2134 3.75 15 3.75ZM5.79545 15C5.79545 9.91631 9.91631 5.79545 15 5.79545C20.0837 5.79545 24.2045 9.91631 24.2045 15C24.2045 20.0837 20.0837 24.2045 15 24.2045C9.91631 24.2045 5.79545 20.0837 5.79545 15Z"
              fill="currentColor" />
          </svg>
        </div>
      </div>
      <div class="content-section">
        <div class="card-title">
          {{ $t("yourPlanRemaining") }} <span class="days-pill success">{{ remainingDays }} {{ $t("day") }}</span>
          <a class="modern-cta" @click.prevent="goToDetail">
            {{ $t("viewDetails") }} <b-icon icon="arrow-up-right" class="ml-1" font-scale="0.8"></b-icon>
          </a>
        </div>
        <div class="card-info">
          {{ $t("countThisMonth") }}: <strong>{{ monthlyMeetingByCustomer }}/{{ numberOfMeetings }}</strong>
        </div>
        <div class="card-footer-text">
          {{ $t("youCanStillHostUpTo") }} <strong>{{ duration }} {{ $t("hours") }}</strong> {{ $t("with") }}
          <strong>{{ maximumNumberOfParticipantsInMeeting }} {{ $t("participants") }}</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'PackageStatus'
})
export default class PackageStatus extends Vue {
  @Prop({ required: true, type: Number }) remainingDays!: number;
  @Prop({ required: true, type: Number }) monthlyMeetingByCustomer!: number;
  @Prop({ required: true, type: Number }) numberOfMeetings!: number;
  @Prop({ required: true, type: Number }) duration!: number;
  @Prop({ required: true, type: Number }) maximumNumberOfParticipantsInMeeting!: number;

  get statusType(): 'expired' | 'limit-reached' | 'expiring-soon' | 'active' {
    // Ưu tiên 1: Đã hết hạn
    if (this.remainingDays <= 0) {
      return 'expired';
    }

    // Ưu tiên 2: Đã đạt giới hạn cuộc họp
    if (this.monthlyMeetingByCustomer >= this.numberOfMeetings) {
      return 'limit-reached';
    }

    // Ưu tiên 3: Sắp hết hạn (dưới 7 ngày)
    if (this.remainingDays <= 7) {
      return 'expiring-soon';
    }

    // Mặc định: Còn hạn bình thường
    return 'active';
  }

  ///
  goToDetail(): void {
    window.open('/app#/account', '_blank');
  }
}
</script>

<style lang="scss" scoped>
.package-status {
  max-width: 100%;
}

.modern-status-card {
  display: flex;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 8px;
  border: 1px solid transparent;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  background: #ffffff;

  &.success {
    background-color: #f3faf5;
    border-color: #def7ec;

    .card-title {
      color: #03543f;
    }
  }

  &.warning {
    background-color: #fdfaf2;
    border-color: #fde8c3;

    .card-title {
      color: #723b13;
    }
  }

  &.danger {
    background-color: #fdf6f6;
    border-color: #fde8e8;

    .card-title {
      color: #9b1c1c;
    }
  }
}

.icon-section {
  flex-shrink: 0;
}

.icon-badge {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.success-badge {
    background: #def7ec;
    color: #03543f;
  }

  &.warning-badge {
    background: #fde8c3;
    color: #723b13;
  }

  &.danger-badge {
    background: #fde8e8;
    color: #9b1c1c;
  }
}

.content-section {
  flex: 1;
}

.card-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.card-info {
  font-size: 13.5px;
  line-height: 1.5;
  color: #4a5568;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;

  &.danger-light {
    color: #b12b2b;
    font-weight: 500;
  }

  &.warning-text {
    color: #b45309;
    font-weight: 500;
  }

  &.secondary {
    color: #4a5568;
  }
}

.card-footer-text {
  font-size: 12px;
  color: #718096;
  margin-top: 10px;
}

.modern-cta {
  font-size: 13px;
  color: #004f9e;
  margin-left: auto;
  text-decoration: none !important;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    color: #003366 !important;
    text-decoration: underline !important;
  }
}

.highlight-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  &.danger {
    background: #fde8e8;
    color: #9b1c1c;
  }
}

.days-pill {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  line-height: 1.4;

  &.success {
    background: #def7ec;
    color: #03543f;
  }

  &.warning {
    background: #fde8c3;
    color: #723b13;
  }
}

.danger-text {
  color: #9b1c1c;
}

@media (max-width: 576px) {
  .modern-status-card {
    flex-direction: column;
    gap: 12px;
  }

  .modern-cta {
    margin-left: 0;
    margin-top: 4px;
    width: fit-content;
  }
}
</style>